import { PropsWithChildren } from 'react';

import { Badge } from '@ravago/shared/radiance/components/badge/components/Badge/Badge';
import { Box } from '@ravago/shared/radiance/components/box/components/Box/Box';
import { Paper } from '@ravago/shared/radiance/components/paper/components/Paper/Paper';
import { Typography } from '@ravago/shared/radiance/components/typography/components/Typography/Typography';
import { useTranslations } from '@ravago/shared/translations/client';

interface Props extends PropsWithChildren {
   title: string;
}

export const RequestForQuotationDesktop = ({ title, children }: Props) => {
   const translate = useTranslations();

   return (
      <Paper border={false} shadow>
         <Box direction="column" gap="lg" spacing={{ x: 'lg', y: 'xl' }}>
            <>
               <Box justify="between" direction="row">
                  <Typography component="h4" variant="heading-4" color="strong">
                     {translate(title)}
                  </Typography>
                  <Badge leadingIcon="bolt" variant="success">
                     {translate('request-for-quotation.fast-response')}
                  </Badge>
               </Box>
               {children}
            </>
         </Box>
      </Paper>
   );
};
